import React from 'react';
import { Box } from '@mui/material';

interface PhotoPreviewProps {
  previewUrls: string[];
  size?: number;
}

export default function PhotoPreview({ previewUrls, size = 100 }: PhotoPreviewProps) {
  if (previewUrls.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
      {previewUrls.map((url, idx) => (
        <Box key={idx} sx={{ position: 'relative' }}>
          <img
            src={url}
            alt={`preview-${idx}`}
            style={{
              width: size,
              height: size,
              objectFit: 'cover',
              borderRadius: 4,
            }}
          />
        </Box>
      ))}
    </Box>
  );
}

